export default __webpack_public_path__ + "static/media/faci07.be0485ec.jpg";